import React from "react";
import { Button, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle } from "@mui/material";
import { useIntl } from "react-intl";

const MemberStatusDialog = ({ member, open, submitting, onClose, onConfirm }) => {
  const intl = useIntl();
  const deactivating = Boolean(member?.is_active);

  return (
    <Dialog open={open} onClose={() => !submitting && onClose()} fullWidth maxWidth="sm">
      <DialogTitle>
        {intl.formatMessage({
          id: deactivating ? "members.lifecycle.deactivateMember" : "members.lifecycle.reactivateMember",
        })}
      </DialogTitle>
      <DialogContent>
        <DialogContentText>
          {intl.formatMessage(
            {
              id: deactivating
                ? "members.lifecycle.deactivateDescription"
                : "members.lifecycle.reactivateDescription",
            },
            { name: member?.name },
          )}
        </DialogContentText>
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose} disabled={submitting}>
          {intl.formatMessage({ id: "Cancelar" })}
        </Button>
        <Button variant="contained" onClick={onConfirm} disabled={submitting}>
          {submitting
            ? intl.formatMessage({ id: "Guardando…" })
            : intl.formatMessage({
                id: deactivating ? "members.lifecycle.deactivate" : "members.lifecycle.reactivate",
              })}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default MemberStatusDialog;
